import React from 'react';
import { Container, createTheme, MantineProvider, Paper, Space } from '@mantine/core';
import { Gifts } from './views/Gifts';
import Header from './components/Header';
import Starfield from './components/StarField';
import { Photos } from './views/Photos';
import { GuestBook } from './views/GuestBook';
import { EventDetails } from './views/EventDetails';

const theme = createTheme({
  breakpoints: {
    xs: '30em',
    sm: '48em',
    md: '64em',
    //lg: '74em',
    lg: '82em',
    xl: '90em',
  },
});

// Create main component to render views
export const App = () => {
  const [activeTab, setActiveTab] = React.useState<string | null>('gifts');
  return (
    <MantineProvider theme={theme}>
      <Container size="xl" my="xl">
        <Starfield
          starCount={1000}
          starColor={[255, 215, 0]}
          speedFactor={0.05}
          backgroundColor="black"
        />
        <Paper withBorder shadow="xs" p={0} style={{ overflow: "hidden" }}>
          <Header activeTab={activeTab} onTabChange={setActiveTab} />
        </Paper>
        <Space h={"xl"} />
        {activeTab === 'gifts' && <Gifts onSignGuestbook={() => setActiveTab("guest book")} />}
        {activeTab === 'photos' && <Photos />}
        {activeTab === 'guest book' && <GuestBook />}
        {activeTab === 'details' && <EventDetails />}
      </Container>
    </MantineProvider>
  );
};
